import { createSelector } from 'reselect';
import { TReduxStorage } from '@/pages/supplies-management/_types/redux-storage';
import { initialState } from './reducer';
import { TWarehousesLimitsStorage } from './types';
import { WAREHOUSES_LIMITS_REDUCER_NAME } from './_constants';

export const warehousesLimitsStorage = (store: TReduxStorage) =>
  store[WAREHOUSES_LIMITS_REDUCER_NAME] || initialState;

export const warehousesSelector = createSelector(
  [warehousesLimitsStorage],
  ({ warehouses }: TWarehousesLimitsStorage) => warehouses,
);

export const coefficientsReportSelector = createSelector(
  [warehousesLimitsStorage],
  ({ coefficientsReport }: TWarehousesLimitsStorage) => coefficientsReport,
);

export const filteredCoefficientsReportSelector = createSelector(
  [warehousesLimitsStorage],
  ({ filteredCoefficientsReport }: TWarehousesLimitsStorage) =>
    filteredCoefficientsReport,
);

export const limitsWarehouseDateSelector = createSelector(
  [warehousesLimitsStorage],
  ({ limitsWarehouseDate }: TWarehousesLimitsStorage) => limitsWarehouseDate,
);

export const areWarehousesLoadingSelector = createSelector(
  [warehousesLimitsStorage],
  ({ areWarehousesLoading }: TWarehousesLimitsStorage) => areWarehousesLoading,
);

export const areLimitsLoadingSelector = createSelector(
  [warehousesLimitsStorage],
  ({ areLimitsLoading }: TWarehousesLimitsStorage) => areLimitsLoading,
);

export const filteredWarehousesSelector = createSelector(
  [warehousesLimitsStorage],
  ({ filteredWarehouses }: TWarehousesLimitsStorage) => filteredWarehouses,
);
export const allowedDatesSelector = createSelector(
  [warehousesLimitsStorage],
  ({ allowedDates }: TWarehousesLimitsStorage) => allowedDates,
);
export const costForPaletteSelector = createSelector(
  [warehousesLimitsStorage],
  ({ costForPalette }: TWarehousesLimitsStorage) => costForPalette,
);
